import { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import ProfileDesktop from '../components/faraaz/ProfileDesktop'
import ProfileMobile from '../components/faraaz/ProfileMobile'
import ProfileImg from '../assets/images/Profile.png'

const ZunairaTazkeerHussain = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            <Helmet>
                <meta name="robots" content="noindex" />
                <meta charSet="utf-8" />
                <title>Zunaira Hussain | Lead Generation Executive - 800 Homes</title>
            </Helmet>

            <section id="website-responsive" className="d-none d-md-block">
                <ProfileDesktop
                    Image={ProfileImg}
                    Title="Zunaira Hussain"
                    Designation="Lead Generation Executive"
                    ORN="44515"
                    PhoneNumberLink="+971585724494"
                    PhoneNumber="+971 58 572 4494"
                    WhatsappLink="971585724494"
                    Whatsapp="+971 58 572 4494"
                    Email="zunaira@800homes.ae"
                />
            </section>

            <section id="website-responsive" className="d-block d-md-none">
                <ProfileMobile
                    Image={ProfileImg}
                    Title="Zunaira Hussain"
                    Designation="Lead Generation Executive"
                    ORN="44515"
                    PhoneNumberLink="+971585724494"
                    PhoneNumber="+971 58 572 4494"
                    WhatsappLink="971585724494"
                    Whatsapp="+971 58 572 4494"
                    Email="zunaira@800homes.ae"
                />
            </section>
        </>
    )
}

export default ZunairaTazkeerHussain
